const PaymentStatus = {
  settled: '決済済み',
  unsettled: '未決済',
};

export default PaymentStatus;



// WEBPACK FOOTER //
// ./src/constants/payment-status.js